import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Select } from "antd";

import If from "~/core/ui/If";

import ConfirmModal from "~/components/ConfirmModal";

import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";

import { useGlobalNewOpportunityModalContext } from "../context";
import { usePipelineSwitching } from "../hooks/usePipelineSwitching";
import { useGlobalCreateOpportunityStore } from "../store";

import PipelineLoadingFallback from "./Loading/PipelineLoadingFallback";

export default function PipelineSwitching() {
  usePipelineSwitching();

  const pipelines = useGlobalCreateOpportunityStore(state => state.pipelines);
  const isPipelinesLoading = useGlobalCreateOpportunityStore(
    state => state.isPipelinesLoading,
  );
  const selectedPipeline = useGlobalCreateOpportunityStore(
    state => state.selectedPipeline,
  );
  const setSelectedPipeline = useGlobalCreateOpportunityStore(
    state => state.setSelectedPipeline,
  );
  const isConfirmClearForm = useGlobalCreateOpportunityStore(
    state => state.isConfirmClearForm,
  );
  const setIsConfirmClearForm = useGlobalCreateOpportunityStore(
    state => state.setIsConfirmClearForm,
  );
  const resetSelection = useGlobalCreateOpportunityStore(
    state => state.resetSelection,
  );
  const resetActiveStateOfSelectTypeAttributes =
    useGlobalCreateOpportunityStore(
      state => state.resetActiveStateOfSelectTypeAttributes,
    );
  const { form, oppNameRef } = useGlobalNewOpportunityModalContext();

  return (
    <div className="flex items-center gap-2 w-full">
      <If
        condition={!isPipelinesLoading}
        fallback={<PipelineLoadingFallback />}
      >
        <Form.Item label="Pipeline" className="w-full">
          <Select
            className="!w-full"
            showSearch
            value={{
              label: selectedPipeline?.label,
              value: selectedPipeline?.value,
            }}
            loading={isPipelinesLoading}
            options={pipelines}
            onSelect={(_, option) => {
              setSelectedPipeline(option);
              oppNameRef?.current?.focus();
            }}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase()) ??
              false
            }
            suffixIcon={<FontAwesomeIcon icon={faChevronDown} />}
          />
        </Form.Item>
      </If>
      <ConfirmModal
        isOpen={isConfirmClearForm}
        onDismiss={() => setIsConfirmClearForm(false)}
        heading="Are you sure you want to clear your data?"
        confirmButtonLabel="Clear data"
        cancelButtonLabel="Cancel"
        onConfirm={() => {
          resetSelection();
          resetActiveStateOfSelectTypeAttributes();
          form?.resetFields();
          setIsConfirmClearForm(false);
        }}
        onCancel={() => {
          setIsConfirmClearForm(false);
        }}
      >
        <div className="text-sm">
          All information you&apos;ve entered in this form will be permanently
          deleted and cannot be recovered.
        </div>
      </ConfirmModal>
    </div>
  );
}
